import { clsx } from 'clsx';
import { CSSProperties, ReactNode } from 'react';
import styles from './PageContainer.module.scss';

interface Props {
  children: ReactNode;
  fullWidth?: boolean;
  dataTestId?: string;
  style?: CSSProperties;
  className?: string;
}

const PageContainer: React.FC<Props> = ({ children, dataTestId, className, style }) => {
  const computedClassName = clsx(styles.pageContainer, className);
  return (
    <div data-testid={dataTestId} className={computedClassName} style={style}>
      {children}
    </div>
  );
};

export default PageContainer;
